import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { soldeActions } from "../../sagas/soldeSlice";
import { Container, Row, Col, Card, CardBody, Button, Form, FormGroup, Label, Input, Table, Spinner } from "reactstrap";
import { FaTruck, FaFileExport, FaSearch, FaBuilding } from "react-icons/fa";
import { useTranslation } from "react-i18next";
import { clientActions } from "../../sagas/clientSlice";
import Select from "react-select";
import { format } from "date-fns";

const MouvementSoldeChantier = () => {
    const { soldes, loading, error } = useSelector((state) => state.soldes);
    const clients = useSelector(state => state.clients.clients);
    const { t } = useTranslation();
    // Get start and end of current month as yyyy-MM-dd
    const startDate = format(new Date(), 'yyyy-MM-dd');
    const endDate = format(new Date(Date.now() + 24 * 60 * 60 * 1000), 'yyyy-MM-dd');
    const [selectedClient, setSelectedClient] = useState(null);

    const [filters, setFilters] = useState({
        clientId: null,
        chantierId: null,
        dateMouvementFrom: startDate,
        dateMouvementTo: endDate,
        typeDocument: ''
    });

    const dispatch = useDispatch();

    useEffect(() => {
        dispatch(clientActions.search({ query: "" }));
        dispatch(soldeActions.searchChantier(filters));
    }, []);

    const handleSearch = (e) => {
        e && e.preventDefault();
        dispatch(soldeActions.searchChantier(filters));
    };

    const handleExport = () => {
        // Logic to handle export of mouvements
        // This could be a call to a service that generates a report or downloads data
    }

    const clientOptions = clients?.map(client => ({
        value: client.id,
        label: client.typeClient === 'PARTICULIER'
            ? `${client.nom} ${client.prenom || ''} `
            : client.entreprise,
        chantiers: client.chantiers || []
    })) ?? [];

    const clientOptionsWithAll = [
        { value: null, label: t('common.all', 'Tous') },
        ...clientOptions
    ];

    // Create chantier options from selected client's chantiers
    const chantierOptions = selectedClient?.chantiers?.map(chantier => ({
        value: chantier.id,
        label: `${chantier.code} - ${chantier.nom}`,
        ...chantier
    })) || [];

    // Calculate summary
    const totalDebit = soldes?.reduce((sum, m) => sum + (Number(m.debit) || 0), 0) || 0;
    const totalCredit = soldes?.reduce((sum, m) => sum + (Number(m.credit) || 0), 0) || 0;
    // solde actuel: last soldeApres if exists, else 0
    const soldeActuel = soldes && soldes.length > 0 ? soldes[soldes.length - 1].soldeApres : 0;

    return (
        <Container fluid>
            <Row className="mb-4">
                <Col>
                    <Card className="shadow-sm">
                        <CardBody className="d-flex justify-content-between align-items-center">
                            <h4 className="mb-0 d-flex align-items-center">
                                <FaTruck className="text-primary me-2" />
                                {t('nav.siteReports', 'Journal des opérations')}
                            </h4>
                            <div className="d-flex align-items-center">
                                <Button
                                    color="success"
                                    onClick={() => handleExport()}
                                    className="me-2"
                                >
                                    <FaFileExport className="me-2" />
                                    {t('export.salesExport', 'Export Etats')}
                                </Button>
                            </div>
                        </CardBody>
                    </Card>
                </Col>
            </Row>
            {/* Search Filters */}
            <Row className="mb-3">
                <Col>
                    <Card className="shadow-sm">
                        <CardBody>
                            <Form inline onSubmit={handleSearch} className="row g-3 ">
                                <Col md={3}>
                                    <Label htmlFor="clientId">{t('bonLivraison.client')}:</Label>
                                    <Select
                                        id="clientId"
                                        options={clientOptionsWithAll}
                                        value={clientOptionsWithAll.find(option => option.value === filters.clientId)}
                                        onChange={(selectedOption) => {
                                            setFilters(f => ({ ...f, clientId: selectedOption ? selectedOption.value : null }));
                                            setSelectedClient(selectedOption);
                                        }}
                                        placeholder={t('bonLivraison.selectClient')}
                                        isSearchable
                                        menuPortalTarget={typeof window !== 'undefined' ? document.body : null}
                                        styles={{
                                            menuPortal: base => ({ ...base, zIndex: 9999 })
                                        }}
                                    />
                                </Col>
                                <Col md={3}>
                                    <Label htmlFor="chantierId">
                                        {t('chantier.title', 'Chantier')}:
                                    </Label>
                                    <Select
                                        id="chantierId"
                                        options={chantierOptions}
                                        value={chantierOptions.find(option => option.value === filters?.chantierId) || null}
                                        onChange={(selectedOption) => setFilters(f => ({ ...f, chantierId: selectedOption ? selectedOption.value : null }))}
                                        placeholder={t('chantier.select', 'Sélectionner...')}
                                        isSearchable
                                        isClearable
                                        menuPortalTarget={typeof window !== 'undefined' ? document.body : null}
                                        styles={{
                                            menuPortal: base => ({ ...base, zIndex: 9999 })
                                        }}
                                    />
                                </Col>
                                <Col md={2}>
                                    <FormGroup>
                                        <Label for="dateMouvementFrom">Date début</Label>
                                        <Input
                                            type="date"
                                            id="dateMouvementFrom"
                                            value={filters.dateMouvementFrom}
                                            onChange={e => setFilters(f => ({ ...f, dateMouvementFrom: e.target.value }))}
                                        />
                                    </FormGroup>
                                </Col>
                                <Col md={2}>
                                    <FormGroup>
                                        <Label for="dateMouvementTo">Date fin</Label>
                                        <Input
                                            type="date"
                                            id="dateMouvementTo"
                                            value={filters.dateMouvementTo}
                                            onChange={e => setFilters(f => ({ ...f, dateMouvementTo: e.target.value }))}
                                        />
                                    </FormGroup>
                                </Col>
                                {/* <Col md={3}>
                                    <FormGroup>
                                        <Label for="typeDocument">Type Document</Label>
                                        <Input
                                            type="select"
                                            id="typeDocument"
                                            value={filters.typeDocument}
                                            onChange={e => setFilters(f => ({ ...f, typeDocument: e.target.value }))}
                                        >
                                            <option value="">Tous</option>
                                            <option value="FACTURE">Facture</option>
                                            <option value="BON_LIVRAISON">Bon de livraison</option>
                                            <option value="DEVIS">Devis</option>
                                            <option value="AVOIR">Avoir</option>
                                            <option value="PAIEMENT">Paiement</option>
                                            <option value="AVANCE">Avance</option>
                                            <option value="AJUSTEMENT_MANUEL">Ajustement manuel</option>
                                        </Input>
                                    </FormGroup>
                                </Col> */}
                                <Col md={2} >
                                    <Button color="primary" type="submit" className="mt-4">
                                        <FaSearch className="me-2" />
                                        {t('search', 'Rechercher')}
                                    </Button>
                                </Col>
                            </Form>
                        </CardBody>
                    </Card>
                </Col>
            </Row>
            {/* Table of mouvements */}
            <Row>
                <Col>
                    <Card className="shadow-sm">
                        <CardBody>
                            {loading ? (
                                <div className="text-center my-4"><Spinner color="primary" /></div>
                            ) : error ? (
                                <div className="text-danger">Erreur lors du chargement des mouvements.</div>
                            ) : (
                                <Table bordered hover size="sm" className="mb-0 align-middle">
                                    <thead className="table-primary">
                                        <tr>
                                            <th >Référence</th>
                                            <th >Client</th>
                                            <th >Chantier</th>
                                            <th >Opération</th>
                                            <th >Date Opération</th>
                                            <th >Débit</th>
                                            <th>Crédit</th>
                                            <th >Solde Avant</th>
                                            <th >Solde Après</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {soldes && soldes.length > 1 ? (
                                            soldes.map((m, idx) => (
                                                <tr key={idx} className={idx === 0 ? 'fw-bold' : ''}>
                                                    <td>{m.reference}</td>
                                                    <td>{m.client}</td>
                                                    <td>{m.chantier}</td>
                                                    <td>{m.description}</td>
                                                    <td>{m.dateOperation}</td>
                                                    <td>{m.debit}</td>
                                                    <td>{m.credit}</td>
                                                    <td>
                                                        {Number(m.soldeAvant) > 0 ? (
                                                            <b><span className="text-success">+{Math.abs(Number(m.soldeAvant)).toLocaleString()}</span></b>
                                                        ) : Number(m.soldeAvant) < 0 ? (
                                                            <b><span className="text-danger">-{Math.abs(Number(m.soldeAvant)).toLocaleString()}</span></b>
                                                        ) : (
                                                            <b><span className="text-dark">0</span></b>
                                                        )}
                                                    </td>
                                                    <td>
                                                        {Number(m.soldeApres) > 0 ? (
                                                            <b><span className="text-success">+{Math.abs(Number(m.soldeApres)).toLocaleString()}</span></b>
                                                        ) : Number(m.soldeApres) < 0 ? (
                                                            <b><span className="text-danger">-{Math.abs(Number(m.soldeApres)).toLocaleString()}</span></b>
                                                        ) : (
                                                            <b><span className="text-dark">0</span></b>
                                                        )}
                                                    </td>
                                                </tr>
                                            ))
                                        ) : (
                                            <tr>
                                                <td colSpan={10} className="text-center py-5">
                                                    <div className="d-flex flex-column align-items-center justify-content-center">
                                                        <span style={{ fontSize: '2rem', color: '#adb5bd' }}>
                                                            <FaTruck />
                                                        </span>
                                                        <div className="mt-2 text-muted">
                                                            {t('mouvements.noData', 'Aucun mouvement trouvé.')}
                                                        </div>
                                                    </div>
                                                </td>
                                            </tr>
                                        )}
                                    </tbody>
                                    {soldes && soldes.length > 1 ? (<tfoot className="table-light">
                                        <tr className="table-secondary fw-bold">
                                            <td colSpan={5} className="text-end">Totaux :</td>
                                            <td>{totalDebit.toLocaleString()}</td>
                                            <td>{totalCredit.toLocaleString()}</td>
                                            <td colSpan={2} className="text-start">
                                                {`Solde au ${filters.dateMouvementTo} : `}
                                                {Number(soldeActuel) > 0 ? (
                                                    <b><span className="text-success">+{Math.abs(Number(soldeActuel)).toLocaleString()}</span></b>
                                                ) : Number(soldeActuel) < 0 ? (
                                                    <b><span className="text-danger">-{Math.abs(Number(soldeActuel)).toLocaleString()}</span></b>
                                                ) : (
                                                    <b><span className="text-dark">0</span></b>
                                                )}
                                            </td>
                                        </tr>
                                    </tfoot>) : null}
                                </Table>
                            )}
                        </CardBody>
                    </Card>
                </Col>
            </Row>
        </Container>
    );

}

export default MouvementSoldeChantier;